import { Badge } from '@/components/ui/badge';
import { Trophy, XCircle, Clock, AlertCircle } from 'lucide-react';
import { BidOutcome } from '@/types/bidHistory';

interface BidOutcomeBadgeProps {
  outcome: BidOutcome;
  className?: string;
}

export function BidOutcomeBadge({ outcome, className }: BidOutcomeBadgeProps) {
  const config = {
    won: {
      label: 'Won',
      icon: Trophy,
      variant: 'default' as const,
      className: 'bg-green-500/10 text-green-600 border-green-500/20 hover:bg-green-500/20',
    },
    lost: {
      label: 'Lost',
      icon: XCircle,
      variant: 'secondary' as const,
      className: 'bg-red-500/10 text-red-600 border-red-500/20 hover:bg-red-500/20',
    },
    pending: {
      label: 'Pending',
      icon: Clock,
      variant: 'outline' as const,
      className: 'bg-yellow-500/10 text-yellow-600 border-yellow-500/20 hover:bg-yellow-500/20',
    },
    expired: {
      label: 'Expired',
      icon: AlertCircle,
      variant: 'secondary' as const,
      className: 'bg-muted text-muted-foreground',
    },
  };

  const { label, icon: Icon, className: badgeClassName } = config[outcome];

  return (
    <Badge 
      variant="outline"
      className={`${badgeClassName} flex items-center gap-1 font-medium ${className || ''}`}
    >
      <Icon className="h-3 w-3" />
      {label}
    </Badge>
  );
}
